import React from "react";

export default function UnsupportedJourneyItem({ question }) {
  const identity = question?.release_node_id || question?.id || "unknown";
  return (
    <div className="treatment-journey-unsupported" role="alert">
      <h3>This configured questionnaire item is not supported</h3>
      <p>
        Item <code>{String(identity)}</code> uses type{" "}
        <code>{String(question?.question_type || question?.kind || "unknown")}</code>.
        Update the Program configuration before patients continue.
      </p>
    </div>
  );
}
